import { render, staticRenderFns } from "./Vest.vue?vue&type=template&id=113aa0a0&scoped=true&"
import script from "./Vest.vue?vue&type=script&lang=js&"
export * from "./Vest.vue?vue&type=script&lang=js&"
import style0 from "./Vest.vue?vue&type=style&index=0&id=113aa0a0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113aa0a0",
  null
  
)

export default component.exports